import { makeRequest } from './data_utils';

const getProfile = () => {
    return makeRequest('profile/', 'GET');
};

const updateProfile = (payload) => {
    return makeRequest('profile/', 'PUT', payload);
};

export const profileData = {
    getProfile,
    updateProfile
};
